import { createAction } from "@reduxjs/toolkit";
import {
  getConversationsActionTypes,
  getMessagesActionTypes,
  getMoreConversationsActionTypes,
  getMoreMessagesActionTypes,
  hideConversationActionTypes,
  conversationUpdateActionTypes,
  messageReceivedActionTypes,
  messageReceivedUnreadCountActionTypes,
  addMessageActionTypes,
  removeMessageActionTypes,
  deleteMessageActionTypes,
  sendMessageActionTypes,
  messageSentActionType,
  createConversationActionTypes,
  getConversationDetailsActionTypes,
  markAsReadActionTypes,
  updateConversationActionType,
  markMessagesInConversationReadActionType,
  messageDeletedActionTypes,
  leaveChatActionType,
  getUnreadCountActionTypes,
  editMessageActionTypes,
  setEditMessageIdActionType,
  resetEditMessageIdActionType,
  messageEditedActionTypes,
  newConversationReceivedActionTypes,
  addConversationActionTypes,
  addProposalMessageActionTypes,
  addConversationDetailsActionTypes,
} from "./actionTypes";

export const getConversationDetails = createAction(
  getConversationDetailsActionTypes.request,
);
export const getConversationDetailsSuccess = createAction(
  getConversationDetailsActionTypes.success,
);
export const getConversationDetailsFailure = createAction(
  getConversationDetailsActionTypes.failure,
);

export const getConversations = createAction(
  getConversationsActionTypes.request,
);
export const getConversationsSuccess = createAction(
  getConversationsActionTypes.success,
);
export const getConversationsFailure = createAction(
  getConversationsActionTypes.failure,
);

export const getMoreConversations = createAction(
  getMoreConversationsActionTypes.request,
);
export const getMoreConversationsSuccess = createAction(
  getMoreConversationsActionTypes.success,
);
export const getMoreConversationsFailure = createAction(
  getMoreConversationsActionTypes.failure,
);

export const getMessages = createAction(getMessagesActionTypes.request);
export const getMessagesSuccess = createAction(getMessagesActionTypes.success);
export const getMessagesFailure = createAction(getMessagesActionTypes.failure);

export const getMoreMessages = createAction(getMoreMessagesActionTypes.request);
export const getMoreMessagesSuccess = createAction(
  getMoreMessagesActionTypes.success,
);
export const getMoreMessagesFailure = createAction(
  getMoreMessagesActionTypes.failure,
);

export const hideConversation = createAction(
  hideConversationActionTypes.request,
);

export const deleteMessage = createAction(deleteMessageActionTypes.request);
export const deleteMessageSuccess = createAction(
  deleteMessageActionTypes.success,
);

export const markAsRead = createAction(markAsReadActionTypes.request);
export const markAsReadSuccess = createAction(markAsReadActionTypes.success);

export const updateConversation = createAction(updateConversationActionType);
export const markMessagesInConversationRead = createAction(
  markMessagesInConversationReadActionType,
);

export const leaveChat = createAction(leaveChatActionType);

export const editMessage = createAction(editMessageActionTypes.request);
export const editMessageSuccess = createAction(editMessageActionTypes.success);
export const editMessageFailure = createAction(editMessageActionTypes.failure);

export const setEditMessageId = createAction(setEditMessageIdActionType);
export const resetEditMessageId = createAction(resetEditMessageIdActionType);

export const conversationUpdateSuccess = createAction(
  conversationUpdateActionTypes.success,
);

export const messageReceivedSuccess = createAction(
  messageReceivedActionTypes.success,
);

export const getUnreadCount = createAction(getUnreadCountActionTypes.request);
export const getUnreadCountSuccess = createAction(
  getUnreadCountActionTypes.success,
);
export const getUnreadCountFailure = createAction(
  getUnreadCountActionTypes.failure,
);

export const messageReceivedUnreadCountSuccess = createAction(
  messageReceivedUnreadCountActionTypes.success,
);

export const addMessage = createAction(addMessageActionTypes.success);
export const removeMessage = createAction(removeMessageActionTypes.success);

export const addProposalMessage = createAction(
  addProposalMessageActionTypes.success,
);

export const addConversation = createAction(addConversationActionTypes.success);

export const sendMessage = createAction(sendMessageActionTypes.request);
export const sendMessageSuccess = createAction(sendMessageActionTypes.success);
export const sendMessageFailure = createAction(sendMessageActionTypes.failure);

export const createConversation = createAction(
  createConversationActionTypes.request,
);
export const createConversationSuccess = createAction(
  createConversationActionTypes.success,
);
export const createConversationFailure = createAction(
  createConversationActionTypes.failure,
);

export const createConversationReset = createAction(
  createConversationActionTypes.reset,
);

export const removeMessageFromConversation = createAction(
  messageDeletedActionTypes.success,
);

export const messageEditedSuccess = createAction(
  messageEditedActionTypes.success,
);

export const setIsSentStatus = createAction(messageSentActionType);

export const newConversationReceivedSuccess = createAction(
  newConversationReceivedActionTypes.success,
);

export const addConversationDetails = createAction(
  addConversationDetailsActionTypes,
);
